<template>
  <v-menu ref="menu" v-model="showPicker" v-bind="menuOptions">
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
        :value="value"
        readonly
        append-icon="mdi-clock"
        v-bind="{ ...attrs, ...textFieldOptions }"
        v-on="on"
      />
    </template>
    <time-picker-board
      v-if="showPicker"
      :value="value"
      @input="selectTime"
      :minute-step="15"
    />
  </v-menu>
</template>

<script>
import TimePickerBoard from '@/components/Helper/Pickers/TimePickerBoard.vue';

export default {
  name: 'CTimePicker',
  components: { TimePickerBoard },
  props: {
    value: {
      required: true,
    },
    type: {
      required: false,
    },
    textFieldOptions: {
      default: () => ({
        label: 'Picker in menu',
        outlined: true,
      }),
    },
    menuOptions: {
      default: () => ({
        closeOnContentClick: false,
        transition: 'scale-transition',
        offsetY: true,
        maxWidth: '290px',
        minWidth: '290px',
      }),
    },
  },
  data: () => ({
    showPicker: false,
  }),
  methods: {
    selectHours(val) {
      if (this.type === 'hour') {
        this.selectTime(`${val}:00`);
      }
    },
    selectTime(val) {
      this.$emit('input', val);
    },
  },
};
</script>

<style lang="sass">
.input-text-center
  input
    text-align: center!important
</style>
